import { render, staticRenderFns } from "./LoanTransactions.vue?vue&type=template&id=46d1130a&scoped=true"
import script from "./LoanTransactions.vue?vue&type=script&lang=js"
export * from "./LoanTransactions.vue?vue&type=script&lang=js"
import style0 from "./LoanTransactions.vue?vue&type=style&index=0&id=46d1130a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46d1130a",
  null
  
)

export default component.exports